/** RBAC roles assignable via Finance User Management invite (v1). */
const INVITE_ALLOWED_RBAC_ROLE_NAMES = ['Finance Manager'] as const

export const isInviteAllowedRbacRoleName = (name: string): boolean =>
  INVITE_ALLOWED_RBAC_ROLE_NAMES.some(
    (allowed) => allowed.toLowerCase() === name.toLowerCase()
  )
